export default __webpack_public_path__ + "static/media/circle.66f2d888.svg";